<template>
  <div>
    <Legenda :titulo="TITULO">
      <v-btn
        v-if="habilitar_botao_grande"
        color="primary"
        :small="habilitar_botao_grande"
        @click="dialog_confirmacao_ativo = true"
      >
        <v-icon v-if="DESCONSIDERAR_PEDIDO_TRANSITO" size="22">$TruckRemove</v-icon>
        <v-icon v-else size="22">mdi-truck-delivery</v-icon>

        <span v-if="habilitar_botao_grande" class="ml-1">
          {{ DESCONSIDERAR_PEDIDO_TRANSITO ? 'Desconsiderar' : 'Considerar' }} pedido{{ pedidos.length > 1 ? 's' : ''}}
        </span>
      </v-btn>

      <v-btn v-else icon @click="dialog_confirmacao_ativo = true">
        <v-icon v-if="!DESCONSIDERAR_PEDIDO_TRANSITO" size="22" color="#999999">$TruckRemove</v-icon>
        <v-icon v-else size="22" color="red">mdi-truck-delivery</v-icon>
      </v-btn>

      <template #legenda>
        <p class="ma-0 text-justify w-min-250" v-html="INFO" />
      </template>
    </Legenda>

    <SysDialog
      v-model="dialog_confirmacao_ativo"
      :titulo="TITULO"
      :largura="500"
      txt-botao="confirmar"
      @click:primary="desconsiderarPedidoCompra"
    >
      <p class="ma-0 mt-n2 pb-2 text-justify" v-html="INFO" />
    </SysDialog>
  </div>
</template>

<script>
import Legenda from "@/components/produto/detalhes/Legenda";
import SysDialog from "@/components/padraoDeLayout/SysDialog";
import {pedidoEmTransitoDesconsiderado} from "@/api/Requisicao";
import {logout} from "@/helpers";

const chaves_obrigatorias_pedidos = ['id_solicitacao', 'idproduto', 'item'];

export default {
  name: "DesconsiderarPedidoEmTransito",
  components: {
    SysDialog,
    Legenda
  },
  props:  {
    pedidos: Array,
    idgrupo: [Number, String],
    habilitar_botao_grande: Boolean,
    tela_compra_materia_prima: {
      type: Boolean,
      default: false
    }
  },
  data: () => ({
    dialog_confirmacao_ativo: false,
    confirmado: false,
  }),
  computed: {
    DESCONSIDERAR_PEDIDO_TRANSITO() {
      return this.pedidos.some(item => !item.pedido_desconsiderado);
    },
    TITULO() {
      return this.DESCONSIDERAR_PEDIDO_TRANSITO ? 'Desconsiderar o pedido em trânsito' : 'Considerar o pedido em trânsito';
    },
    INFO() {
      if (this.DESCONSIDERAR_PEDIDO_TRANSITO) {
        return `
          Marcando essa opção o <span class="font-weight-medium">Systock</span>
          não irá considerar a quantidade em trânsito desse pedido de compra.
        `;
      }

      return `
        Marcando essa opção o <span class="font-weight-medium">Systock</span>
        irá considerar a quantidade em trânsito desse pedido de compra.
      `;
    }
  },
  methods: {
    desconsiderarPedidoCompra() {
      const pedidos = this.pedidos.filter(item => {
        return this.DESCONSIDERAR_PEDIDO_TRANSITO ? !item.pedido_desconsiderado : item.pedido_desconsiderado;
      });

      const parametros = {
        idgrupo: this.idgrupo,
        pedidos: this.Helpers.arrayColumn(pedidos, chaves_obrigatorias_pedidos),
        tela_compra_materia_prima: this.tela_compra_materia_prima,
      };

      this.$store.dispatch('loading/addRequisicao',
        pedidoEmTransitoDesconsiderado(parametros)
          .then(() => {
            this.dialog_confirmacao_ativo = false;
            this.$emit('update:desconsiderar-pedido-em-transito', {});
          })
          .catch(logout)
      );
    }
  }
}
</script>

<style scoped>

</style>
